import React from "react"
import Brick from '../components/brick'

function BrickHistory({data})
{
      let random = Math.floor(Math.random() * ( data.edges.length));

      return (
          <Brick key="h2" thumbnail={data.edges[random].node.frontmatter.thumbnail} caption={`History: ${data.edges[random].node.frontmatter.caption}`} slug="/history" url="/history" styles="brick-3" />
      )

}

export default BrickHistory